import React from 'react';

import { NewIcon } from '../../../../components/newIcon/icon';
import { BenefitDescription, BenefitTileContainer, BenefitTitle } from './pricing-tile.styled';

interface BenefitTileProps {
  benefit: {
    icon: string;
    title: string;
    description: string;
  };
}

export default function BenefitTile({ benefit }: BenefitTileProps) {
  return (
    <BenefitTileContainer>
      <NewIcon size="40px" type={benefit.icon} />

      <BenefitTitle>{benefit.title}</BenefitTitle>
      <BenefitDescription>{benefit.description}</BenefitDescription>
    </BenefitTileContainer>
  );
}
